import { mapGetters } from 'vuex'

/**
 * TODO: Need to rework mixin to factor in list of returned owners as part of
 * TASK #12722
 */
export default {
  computed: {
    ...mapGetters({
      getOwner: 'client/owner',
      getSelectedClients: 'client/getSelectedClients',
      isLoadingClientDetails: 'client/isLoadingClientDetails',
    }),
    owner() {
      return this.getOwner(this.getSelectedClients[0])
    },
    ownerName() {
      return this.owner?.ownerName
    },
    ownerPhone() {
      return this.owner?.ownerPhone
    },
  },
}
